import React from 'react';
import { Flex, Icon } from '@zeal/web-ui';
import { useGetSubscriptionDetails } from '@app/data/Settings/useGetBillingAndPaymentsDetails';
import { InfoIconProps } from '../types';

export default function BannerAlertIcon({ type, onClick }: InfoIconProps) {
	// If no type is provided, don't render (there is no alert to show if no type is provided)
	if (!type) {
		return null;
	}

	return (
		<Flex
			data-testid={`${type}-alert-icon`}
			align="center"
			justify="center"
			className="rounded-full bg-surface-critical-low w-10 h-10 p-2 cursor-pointer"
			onClick={onClick}
		>
			<Icon
				iconName={'triangleExclamation'}
				variant="regular"
				colorVariant="critical"
				size="lg"
			/>
		</Flex>
	);
}
